import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { trans, withClientConfig } from '@spotahome/soyuz/client';

import TextBlock from '@components/TextBlock';

import PhoneScrollerList from '@components/PhoneScrollerList/PhoneScrollerList';
import StaticPhoneList from '@components/PhoneScrollerList/StaticPhoneList';

import { getMediaList, getStaticMediaList } from './PhoneScrollerListConfig';

import './PhoneScrollerSection.scss';

const MQ_MOBILE_MAX_WIDTH = 767;
const MQ_MOBILE_MAX_HEIGHT = 630;

const renderTitle = () => (
  <TextBlock
    title={trans('home.tenant.phone-scroller-section.title')}
    content={trans('home.tenant.phone-scroller-section.subtitle')}
    alignTo="center"
    titleSize="big"
    titleTag="h2"
    contentSize="medium"
    style={{
      maxWidth: '700px',
      margin: 'auto'
    }}
  />
);

const ShowcaseFeatures = ({ clientConfig }) => {
  const hasMinimalWidth = useMediaQuery({
    maxWidth: MQ_MOBILE_MAX_WIDTH
  });
  const hasMinimalHeight = useMediaQuery({
    maxHeight: MQ_MOBILE_MAX_HEIGHT
  });
  const isStaticView = hasMinimalWidth || hasMinimalHeight;

  return (
    <section className="showcase-features">
      {!isStaticView && clientConfig.featureToggle.enablePhoneScrollerList ? (
        <PhoneScrollerList
          scrollerList={getMediaList()}
          titleContent={renderTitle()}
          backgroundColor="white"
        />
      ) : (
        <StaticPhoneList imageList={getStaticMediaList()} />
      )}
    </section>
  );
};

ShowcaseFeatures.propTypes = {
  clientConfig: PropTypes.shape({
    featureToggle: PropTypes.shape({
      enablePhoneScrollerList: PropTypes.bool
    })
  }).isRequired
};

export default withClientConfig()(ShowcaseFeatures);
